import Response from '@/shared/types/response';
import User, { NewUserDetails } from '@/shared/types/user';
import fetcher from '@/shared/utils/fetcher';
import getCookie from '@/shared/utils/getCookie';

type Props = {
  data: NewUserDetails;
};

const createUser = async ({ data }: Props) => {
  const token = getCookie('auth_token');

  try {
    return await fetcher<Response<User[]>>({
      url: '/users/create/',
      method: 'POST',
      token,
      body: data,
    });
  } catch (error) {
    console.error(
      'Error occurred in function "createUser" in file "src/shared/api/auth/createUser.ts":',
      error,
    );
    return error as Response<User[]>;
  }
};

export default createUser;
